export default __webpack_public_path__ + "static/media/Subscription.7659d40e.svg";